import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "normalize.css";

import App from "./App";
import PublicSettingsProvider from "./components/PublicSettingsProvider";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <PublicSettingsProvider>
        <App />
      </PublicSettingsProvider>
    </BrowserRouter>
  </React.StrictMode>
);
